// import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import sessionDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/sessionDataEntry';
import outcomesDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/outcomesDataEntry';
import withModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import courseWrapper from '../../pages/Training/courseWrapper';
const navigations = [courseWrapper, sessionDataEntry, outcomesDataEntry, withModules];

export default navigations;
